import type { FC } from 'react';

import type { MultiSelectFilterValue } from '@iconik-io/shared-lib/src/redux/common_filters/types';

import type { FormFieldEvent } from '../../types';
import { MultiSelectFilterFieldWrapper } from '../multi_select_filter_field/multi_select_filter_field_wrapper';
import { useUserFilterOptions } from '../multi_select_filter_field/option_hooks';

type Props = {
  name: string;
  value?: MultiSelectFilterValue;
  onChange?: (
    value: MultiSelectFilterValue | undefined,
    event?: FormFieldEvent,
  ) => void;
  label?: string;
  subtitle?: string;
  maxRows?: number;
  vertical?: boolean;
  disabled?: boolean;
};

const AVAILABLE_MODIFIERS: ('include_any_of' | 'exclude_any_of')[] = [
  'include_any_of',
  'exclude_any_of',
];

export const MultiSelectFilterUserField: FC<Props> = (props) => {
  const options = useUserFilterOptions(props.name);

  return (
    <MultiSelectFilterFieldWrapper
      {...props}
      loadOptions={options.loadOptions}
      resolveSelectedItems={options.resolveSelectedItems}
      itemLabels={options.itemLabels}
      availableModifiers={AVAILABLE_MODIFIERS}
    />
  );
};
